import React from 'react';

import * as Step from '../components/step';

export const CXIStep9 = () => <Step.Step currentStep={9}>TBD</Step.Step>;
